import React, {Fragment} from 'react';
import PropTypes from 'prop-types';
import {Col, ControlLabel, FormControl, Row, ToggleButton, ToggleButtonGroup, Well} from 'react-bootstrap';
import styled from 'styled-components';
import {DebounceInput} from 'react-debounce-input';

const RGBColorByScore = {
  1: [255, 102, 102],
  2: [255, 130, 102],
  3: [255, 168, 102],
  4: [243, 255, 107],
  5: [108, 249, 146]
};

class AssessmentQuestion extends React.PureComponent {
  getDefaultAnswers = () => {
    return this.props.question.map((a, i) => {
      return (
        <ToggleButton
          disabled={this.props.disabled}
          className={!this.props.disabled ? `btn-block btn-grid score-${i+1}` : `btn-block btn-grid disabled-score-${i+1}`}
          data-cy={a.answer_value}
          key={a.answer_id}
          value={a.answer_id}
          name={a.question_name}
        >
          { this.props.disabled
            ?
            <div className={'h5'}>
                <Fragment>{(a.possible_score * a.question_weight).toFixed(2)} points</Fragment>
            </div>
            :
            <div className={'h5'}>Level {i + 1}</div>
          }
          {a.answer_value}
        </ToggleButton>
      );
    });
  };
  
  getRGBAColorByScore = (score, alpha=1) => {
    return `rgba(${RGBColorByScore[score].join(', ')}, ${alpha})`;
  };

  getBoxColorFromScore = (score) => {
    const answer = this.props.answer.answer;
    let opacity = Math.abs(1 - Math.abs(score - answer));
    if (Math.abs(score - answer) > 1) opacity = 0;
    if (parseInt(answer, 10) === answer) {
      opacity = answer === score ? 1 : 0;
    }

    return this.getRGBAColorByScore(score, opacity.toFixed(1));
  };

  hasComment() {
    return this.props.answer
        && this.props.answer.comment
        && this.props.answer.comment.length > 0;
  }

  getAveragedAnswers = () => {
    return this.props.question.map((a, i) => {
      const answer = (this.props.answer || {}).answer;
      return (
        <ToggleButton
          disabled={this.props.disabled}
          className='btn-block btn-grid'
          style={{ backgroundColor: 'transparent', zIndex: 2 }}
          data-cy={a.answer_value}
          key={a.answer_id}
          value={a.answer_id}
          name={a.question_name}
        >
          { this.props.disabled
            ?
            <div className={'h5'}>
              <Fragment>{(a.possible_score * a.question_weight).toFixed(2)} points</Fragment>
            </div>
            :
            <div className={'h5'}>Level {i + 1}</div>
          }
          {a.answer_value}
          {a.possible_score === Math.floor(answer) &&
            <AnswerColorShade background={this.getRGBAColorByScore(Math.round(answer))} shiftPercent={(answer - a.possible_score) * 100}/>
          }
        </ToggleButton>
      );
    });
  };

  render() {
    let answers = this.props.disabled && this.props.averageScores ? this.getAveragedAnswers() : this.getDefaultAnswers();
    const answer = this.props.answer || {};
    const showCommentInput = !answer.comment || !Array.isArray(answer.comment);
    return (
      <React.Fragment>
        <Row>
          <Col xs={12}>
            <ControlLabel className="h4 pb0">{this.props.question[0].question_name}</ControlLabel>
          </Col>
        </Row>

          {
            this.props.disabled && this.props.averageScores && this.props.answer &&
            <Row>
              <Col xs={12}>
                <ControlLabel>
                  Average Score: &nbsp;
                  {(this.props.answer.answer * this.props.question[0].question_weight).toFixed(2)} / {this.props.question[0].question_weight * 5}
                  </ControlLabel>
              </Col>
            </Row>
          }
        <Row>
          <Col xs={12}>
            <ToggleButtonGroup onChange={(value) => this.props.onSelect(this.props.question[0].question_id, value)} defaultValue={(this.props.answer || {}).answer} justified type="radio" name="answers">
              {answers}
            </ToggleButtonGroup>
          </Col>
        </Row>
        {
          (!this.props.disabled || this.hasComment()) &&

          <Row>
            <Col xs={12}>
              <div className={'mt1 mb3'}>
                {
                  showCommentInput ? (
                    <FormControl value={answer.comment || ''}
                                 disabled={this.props.disabled}
                                 name={this.props.question[0].question_id}
                                 componentClass={DebounceInput}
                                 placeholder="Comments"
                                 style={{resize: 'vertical'}}
                                 onChange={this.onCommentChange}
                                 debounceTimeout={500}
                                 element={'textarea'}
                    />
                  ) : (
                    <Fragment>
                      <ControlLabel>Comments:</ControlLabel>
                      <Well>
                        <ol style={{ paddingLeft: '10px' }}>
                          { this.props.answer.comment &&
                          this.props.answer.comment.map((c, i) => {
                            return <li style={{ marginBottom: '5px' }} key={i}>{c}</li>;
                          })
                          }
                        </ol>
                      </Well>
                    </Fragment>
                  )
                }
              </div>
            </Col>
          </Row>
        }
      </React.Fragment>
    );
  }
  
  onCommentChange = (event) => {
    const value = event.target.value;
    this.props.handleComment(this.props.question[0].question_id, value);
  };
}

const AnswerColorShade = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: ${props => props.shiftPercent}%;
  z-index: -1;
  background-color: ${props => props.background}
`;

AssessmentQuestion.propTypes = {
  question: PropTypes.array.isRequired,
  onSelect: PropTypes.func,
  handleComment: PropTypes.func,
  answer: PropTypes.object,
  disabled: PropTypes.bool,
  averageScores: PropTypes.bool
};

export default AssessmentQuestion;



// WEBPACK FOOTER //
// ./src/components/teams/AssessmentQuestion.js